import { render, staticRenderFns } from "./PatrimonyMoviment.vue?vue&type=template&id=3719074e&scoped=true&"
import script from "./PatrimonyMoviment.vue?vue&type=script&lang=js&"
export * from "./PatrimonyMoviment.vue?vue&type=script&lang=js&"
import style0 from "./PatrimonyMoviment.vue?vue&type=style&index=0&id=3719074e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3719074e",
  null
  
)

export default component.exports